
import SeparatorImg from "../../assets/images/separator.png";

import './SeparatorBar.css';

const SeparatorBar = () => {
  return <div className="separator-bar"></div>;
}
export default SeparatorBar;